import { parseInboundPayload } from '../../inbound';
import { numberParser } from '../../inboundParsers';
import { trimBraces } from '../../inboundUtils';
import { optionalSeatIndexParser } from './pokerInboundUtils';
export function lastActionParser(str) {
    const inboundLastAction = parseInboundPayload(trimBraces(str).split(','), inboundLastActionPartDefinitions);
    if (inboundLastAction.seatIndex === undefined) {
        return null;
    }
    return { ...inboundLastAction, seatIndex: inboundLastAction.seatIndex };
}
// TODO: Use a type guard.
export function lastActionTypeParser(str) {
    return str.toLowerCase();
}
const inboundLastActionPartDefinitions = [
    { name: 'seatIndex', parser: optionalSeatIndexParser },
    { name: 'actionType', parser: lastActionTypeParser },
    { name: 'chipsBetThisRound', parser: numberParser }
];
